import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './header.css';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isShopPage = location.pathname === '/shop';

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <header className={isShopPage ? 'shop-header' : ''}>
      <nav className="menu-bar">
        <div className="nav-container">
          <button className={`hamburger ${menuOpen ? 'active' : ''}`} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>
          <div className="logo">
            <i className="ri-apple-fill"></i>
          </div>

          <ul className="nav-links">
            <li><Link to="/Home">Cửa Hàng</Link></li>
            <li><Link to="/">Mac</Link></li>
            <li><Link to="/">iPad</Link></li>
            <li><Link to="/">iPhone</Link></li>
            <li><Link to="/">Watch</Link></li>
            <li><Link to="/">AirPods</Link></li>
            <li><Link to="/">TV & Nhà</Link></li>
            <li><Link to="/">Giải Trí</Link></li>
            <li><Link to="/">Phụ Kiện</Link></li>
            <li><Link to="/">Hỗ Trợ</Link></li>
          </ul>

          <div className="nav-icons">
            <div className="item"><i className="ri-search-line"></i></div>
            <Link to="/cart" className="item"><i className="ri-shopping-bag-line"></i></Link>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`nav-links-mobile ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
        <ul onClick={(e) => e.stopPropagation()}>
          <li><Link to="/Home">Cửa Hàng</Link></li>
          <li><Link to="/">Mac</Link></li>
          <li><Link to="/">iPad</Link></li>
          <li><Link to="/">iPhone</Link></li>
          <li><Link to="/">Watch</Link></li>
          <li><Link to="/">AirPods</Link></li>
          <li><Link to="/">TV & Nhà</Link></li>
          <li><Link to="/">Giải Trí</Link></li>
          <li><Link to="/">Phụ Kiện</Link></li>
          <li><Link to="/">Hỗ Trợ</Link></li>
        </ul>
      </div>
    </header>
  );
}

export default Header;
